import {
	ZodDiscriminatedUnion,
	type ZodDiscriminatedUnionOption,
	ZodIntersection,
	ZodObject,
	type ZodRawShape,
	ZodTypeAny,
} from 'zod';


export function getNestedSchema(schema: ZodObject<ZodRawShape>, path: string): ZodTypeAny | undefined {
	const parts = path.split('.');

	if (parts.length === 0) {
		return schema;
	}

	let current: ZodTypeAny | undefined = schema;

	if (schema instanceof ZodIntersection) {
		current = getNestedSchema((schema as ZodIntersection<ZodObject<ZodRawShape>, ZodObject<ZodRawShape>>)._def.left, path);
		if (!current) {
			current = getNestedSchema((schema as ZodIntersection<ZodObject<ZodRawShape>, ZodObject<ZodRawShape>>)._def.right, path);
			if (!current) {
				return undefined; // Neither left nor right found the path.
			}
		}
	}

	if (schema instanceof ZodDiscriminatedUnion) {
		for (const option of (schema as ZodDiscriminatedUnion<string, ZodDiscriminatedUnionOption<string>[]>)._def.options) {
			current = getNestedSchema(option, path);
			if (current) {
				break;
			}
		}
	}

	for (const part of parts) {
		if (current instanceof ZodObject) {
			current = (current as ZodObject<ZodRawShape>).shape[part];
		}
	} // for

	// console.debug('getNestedSchema', path, current, current?.isOptional(), current?.isNullable());

	return current;
}
